import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from "@angular/core";
import {FormModalService} from "../../../root/form-modal/form-modal.service";
import {EvaButton} from "../../../shared/eva-button/eva-button";
import {ActivatedRoute} from "@angular/router";
import {RestrictionsService} from "../restrictions.service";
import {SpecialSettingConfig} from "../special-settings/special-setting";
import {FormBuilder, Validators} from "@angular/forms";
import {ErrorMessage} from "../../../shared/sara-input/error-message";
import {NotificationService} from "../../../root/toast/notification.service";
import {TranslateService} from "@ngx-translate/core";
import {DateService} from "../../../core/date.service";
import {GAService} from "../../../root/ga/ga.service";
import {RestrictionsFormValidator} from "../restrictions-form-validator";
import {SaraSelectComponent} from "../../../shared/sara-select/sara-select.component";

@Component({
    selector: 'modal-special-settings',
    providers: [DateService, GAService],
    templateUrl: './modal-special-settings.component.html'
})

export class ModalSpecialSettingsComponent implements OnChanges, OnInit{
    companyOid;
    errors:any;
    dateAndPos: string = "Fecha";
    alwaysPos: string = "Fecha y sucursal";
    specificPosAndDate: string = "Sucursal";
    saveButton:EvaButton;
    @Input() pointsOfSale: any;
    @Input() selectedSpecialValue: any;
    @Input() restrictions;
    @Input() openModal;
    @Input() posListForSelect;

    @ViewChild("maxRentalLength")
    maxRentalLengthSelect: SaraSelectComponent;
    selectReleaseList = this.restrictionsService.getDaysInAdvanceList();
    selectMinDurationList = this.restrictionsService.getMinDurationList();
    @Output() savePosRestriction:EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('modalSpecialForm') form;

    calendarConfig = {
        position: 'topLeft',
        format: 'DD/MM/YYYY',
        disable: true
    };

    selectMaxDurationList;

    private errorMessages = {
        'posName': 'common.error.REQUIRED',
        'minRentalLength': 'common.error.REQUIRED',
        'maxRentalLength': 'common.error.REQUIRED'
    };
    selectedValue:SpecialSettingConfig = new SpecialSettingConfig();
    defaultSelectOption = {
        active: true,
        text: 'restrictions.SPECIAL_CONFIG.MODAL.allPos',
        id: -1
    };

    categories = [
        {
            'value': 'restrictions.SPECIAL_CONFIG.MODAL.subtitle4.checkbox1',
            'id': 'date_always',
            'disable': true
        },
        {
            'value': 'restrictions.SPECIAL_CONFIG.MODAL.subtitle4.checkbox2',
            'id': 'date_range',
            'disable': false
        }
    ];

    constructor(private route:ActivatedRoute,
                private formModalService: FormModalService, private toast:NotificationService,
                private restrictionsService: RestrictionsService, private _fb: FormBuilder,
                private translate: TranslateService, private dateService: DateService,
                public gaService:GAService){
        this.saveButton = new EvaButton('common.SAVE', '-primary', '-md');
        this.companyOid = route.snapshot.params['id'];
    }

    onMinRentalLengthChange() {
        let currentMax = this.selectedSpecialValue.maxRentalLength;
        if (this.selectedSpecialValue.minRentalLength >= this.selectedSpecialValue.maxRentalLength) {
            this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.selectedSpecialValue.minRentalLength);
            this.selectedSpecialValue.maxRentalLength = this.selectedSpecialValue.minRentalLength + 1;
            this.maxRentalLengthSelect.model = this.selectedSpecialValue.maxRentalLength;
        } else {
            this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.selectedSpecialValue.minRentalLength);
            this.maxRentalLengthSelect.model = currentMax;
        }
    }

    onchangePos(){
        if(this.selectedSpecialValue.pointOfSaleOid == -1){
            this.selectedSpecialValue.dateConfigRange = "date_range";
        }
    }

    ngOnChanges (changes: SimpleChanges){
        let context = this;
        if(!!this.selectedSpecialValue){
            this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.selectedSpecialValue.minRentalLength);
        }

    }

    ngOnInit(){
        this.buildForm();
        this.errors = {};
    }


    //agregar por cada posOid que tiene la rentadora una nueva restricción (aplica cuando
    //se eligen todas las sucursales)
    addRestrictionByPosOid(restriction){
        var pos = this.pointsOfSale;
        for (var i in pos){
            restriction.pointOfSaleOid = pos[i].oid;
            this.addSpecialSetting(restriction, this.dateAndPos);
        }
    }

    displayToastError(){
        this.toast.notifyErrorByCode('restrictions.message.error.range');
    }

    private translateRestriction(selectedSpecialValue: any) {
        return {
            validity:selectedSpecialValue.dateConfigRange == "date_always"?{from:null, to:null}:
                {from:selectedSpecialValue.period.from,
                    to:selectedSpecialValue.period.to},
            minRentalLength:selectedSpecialValue.minRentalLength,
            maxRentalLength:selectedSpecialValue.maxRentalLength,
            daysInAdvance:selectedSpecialValue.daysInAdvance,
            oid:selectedSpecialValue.oid,
            pointOfSaleOid: selectedSpecialValue.pointOfSaleOid
        }
    }

    saveRestriction(){
        let restriction = this.translateRestriction(this.selectedSpecialValue);
        this.bindRestrictionForm(restriction);
        let gaArg = this.selectedSpecialValue.dateConfigRange == "date_always"?this.alwaysPos:this.specificPosAndDate;
        if(this.form.valid){
            if(this.selectedSpecialValue.dateConfigRange != "date_always"){
                restriction.validity.from = this.dateService.formatDateToYYYYMMDD(restriction.validity.from);
                restriction.validity.to = this.dateService.formatDateToYYYYMMDD(restriction.validity.to);
            }
            if(!!restriction.oid){
                this.updateSpecialSetting(restriction, gaArg);
            }else{
                if(restriction.pointOfSaleOid == -1){
                    this.addRestrictionByPosOid(restriction);
                }else{
                    this.addSpecialSetting(restriction, gaArg);
                }
            }
        }else{
            this.showErrors();
        }
    }

    private buildForm() {
        this.form = this._fb.group({
            posName: ['', [Validators.required]],
            daysInAdvance: ['', [Validators.required]],
            minRentalLength: ['', [Validators.required, RestrictionsFormValidator.positiveValueWrapper]],
            maxRentalLength: ['', [Validators.required, RestrictionsFormValidator.lengthComparator]],
            period: ['', RestrictionsFormValidator.periodValidator]
        });
    }

    addSpecialSetting(restriction, arg){
        this.restrictionsService.addPosRestriction(restriction, this.companyOid).subscribe((result) => {
            this.savePosRestriction.emit(restriction);
            this.sendGA(arg);
            this.persistCallback();
        }, err => {
            this.errorMessage(err);
            /*Observable.throw(err.json().error);
            throw err;*/
        });
    }

    errorMessage(err){
        switch(err._body){
            case '[\"ERROR.restrictions.validity.fromBeforeToday\"]':{
                this.toast.notifyErrorByCode('restrictions.message.error.before_today');
                break;
            }
            case '[\"ERROR.restrictions.pointOfSale.existentDefault\"]':{
                this.toast.notifyErrorByCode('restrictions.message.error.existent_default');
                break;
            }
            case '{\"message":"Point of sale -1 not found\"}':{
                this.toast.notifyErrorByCode('common.ERROR_500');
                break;
            }
            default : {
                this.toast.notifyErrorByCode('restrictions.message.error.range');
                break;
            }
        }
    }

    sendGA(arg){
        this.gaService.notify("Autos_anticipación_duración", "Guardar_configuración_especial", [arg]);
    }

    updateSpecialSetting(restriction, arg){
        this.restrictionsService.updatePosRestriction(restriction, this.companyOid).subscribe((result) => {
            this.savePosRestriction.emit(restriction);
            this.persistCallback();
            this.sendGA(arg);
        }, err => {
            console.log(err);
            this.errorMessage(err);
            /*Observable.throw(err);
            throw err;*/
        });
    }

    private persistCallback(){
        this.formModalService.hideFormModal(false);
        this.toast.displayToast('restrictions.TITLE','common.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
    }

    private showErrors() {
        this.errors = {};
        for(var i in this.form.controls){
            if(!this.form.controls[i].valid){
                this.errors[i] = new ErrorMessage('-invalid', this.errorMessages[i]);
            }
        }
    }

    getValidityPeriodErrors() {
        let errors : any = {};
        if (this.form.controls["period"].invalid) {
            let formErrors = this.form.controls["period"].errors;
            if (formErrors.requiredFrom) {
                errors.from = new ErrorMessage("-invalid", this.translate.instant("common.INVALID_DATE"));
            }
            if (formErrors.requiredTo) {
                errors.to = new ErrorMessage("-invalid", this.translate.instant("common.INVALID_DATE"));
            }
            if (formErrors.invalidRange) {
                errors.to = new ErrorMessage("-invalid", "Por favor ingrese rango de fechas válido.");
            }
        }
        return errors;
    }


    onPeriodUpdated(event) {
        this.form.controls["period"].updateValueAndValidity();
    }

    onChangeConfigRange(){
        if(this.selectedSpecialValue.dateConfigRange == 'date_always'){
            this.selectedSpecialValue.period = {from: null,to: null};
        }
    }

    private bindRestrictionForm(restriction) {
        this.form.controls['posName'].setValue(restriction.pointOfSaleOid);
        this.form.controls['daysInAdvance'].setValue(restriction.daysInAdvance);
        this.form.controls['minRentalLength'].setValue(restriction.minRentalLength);
        this.form.controls['maxRentalLength'].setValue({minRentalLength: restriction.minRentalLength, maxRentalLength: restriction.maxRentalLength});
        this.form.controls["period"].setValue({period:restriction.validity, config:this.selectedSpecialValue.dateConfigRange});
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/modal-special-settings/modal-special-settings.component.ts